import React, { FC, useEffect, useRef, useState } from "react";
import { Input, Button, Row, Col, Tabs, Spin, Empty } from "antd";
import { SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import { GET_PAGE, GET_ADMIN_GROUPS, GET_AGGREGATE } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { ReactSVG } from "react-svg";

import {
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";

import AvatarItem from "./AvatarItem";
import { getRole } from "utils/chatUtils";
import { UserRoles, formatForRedis } from "utils/appUtil";
import MembersPopup from "./MembersPopup";
import { pushNotification } from "utils/notifications";
import PageAvatarItem from "./PageAvatarItem";
import { formatUserFilterText } from "utils/appUtil";
const { TabPane } = Tabs;

let timeout;

const AddPeople: FC<{
  onClose?: () => void;
  socket?: ISocket;
  isCreatePage?: boolean;
  onDone?: (
    allMarkedUsers: any[],
    allMarkedGroups: any[],
    allMarkedPages: any[]
  ) => void;
}> = ({ onClose, socket, isCreatePage, onDone }) => {
  const {
    selectedItem,
    userSearchPage,
    adminSearchGroup,
    groupSearchTimestamp,
  } = useSelector((state: RootState) => state.search);
  const { findUsersToPage, allUsers, searchTimestamp } = useSelector(
    (state: RootState) => state.auth
  );

  enum tabs {
    People = "people",
    Groups = "groups",
    Pages = "pages",
  }

  const [selectedUsers, setSelectedUsers] = useState<any>({});
  const [selectedGroups, setSelectedGroups] = useState<any>({});
  const { projects } = useSelector((state: RootState) => state.dashboard);
  const [searchInput, setSearchInput] = useState("");
  const [selectedFilter, setSelectedFilter] = useState<string>(tabs.People);
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const [markedUsers, setMarkedUsers] = useState<any[]>([]);
  const [combinedUsers, setCombinedUsers] = useState<any[]>([]);
  const [markedGroups, setMarkedGroups] = useState<any[]>([]);
  const [combinedGroups, setCombinedGroups] = useState<any[]>([]);
  const [markedPages, setMarkedPages] = useState<any[]>([]);
  const [combinedPages, setCombinedPages] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMembersLoading, setIsMembersLoading] = useState(false);
  const [isDoneBtnLoading, setIsDoneBtnLoading] = useState(false);
  const [aggregateUsers, setAggregateUsers] = useState<any[]>([]);

  const dispatch = useDispatch();

  const { getLocalStorageItem } = useLocalStorageService();


  const formatAggregateUserResponse = (response) => {
    let resolvedData = [];
    let profiles = [];
    response?.map((user) => {
      if (Array.isArray(user?.profile)) {
        let temp = {
          objectIds: user?.objectId,
          status: user?.status,
          profile: undefined,
          email: undefined,
          phone: undefined,
          profileImage: undefined,
          beamIds: undefined,
          roleId: undefined,
          department: undefined,
        };
        user?.profile.map((x) => {
          const parsed = JSON.parse(x)?.live;
          const admin = JSON.parse(x)?.admin;
          if (parsed?.alternativeIds?.email) {
            temp.email = parsed?.alternativeIds?.email
          }
          if (parsed?.alternativeIds?.phone) {
            temp.phone = parsed?.alternativeIds?.phone
          }
          if (parsed?.profile?.firstName || parsed?.profile?.firstName) {
            temp.profile = parsed?.profile
          }
          if (parsed?.beamIds?.[0]) {
            temp.beamIds = parsed?.beamIds
          }
          if (parsed?.profile?.profileImage?.urls?.original?.url) {
            temp.profileImage = parsed?.profile?.profileImage;
          }
          if (admin?.profile?.roleId) {
            temp.roleId = admin?.profile?.roleId;
          }
        });
        if (temp) {
          profiles.push(temp);
        }
      } else {
        profiles.push({
          objectIds: user.objectId,
          status: user?.status,
          profile: user?.profile?.live?.profile,
          beamIds: user?.profile?.live?.beamIds,
          email: user?.profile?.live?.alternativeIds?.email,
          phone: user?.profile?.live?.alternativeIds?.phone,
          profileImage: user?.profile?.live?.profile?.profileImage,
          roleId: user?.profile?.admin?.profile?.roleId
        });
      }
    });
    try {
      resolvedData = profiles
        ?.filter((user) => {
          return user.email || user.phone || user.beamIds?.[0] || user.profile?.firstName || user.profile?.lastName;
        })
        ?.map((user) => {
          return {
            id: user.objectIds.toString(),
            name:
              user?.profile?.firstName || user.profile?.lastName
                ? (user?.profile?.firstName || "") +
                " " +
                (user.profile?.lastName || "")
                : `user# ${user.objectIds.toString()}`,
            firstName: user?.profile?.firstName ?? "",
            lastName: user?.profile?.lastName ?? "",
            gender: user?.profile?.gender ?? "",
            dob: user?.profile?.dob ?? "",
            email: user.email,
            phone: user.phone,
            beamId:
              user?.beamIds?.[0]?.toLowerCase() ||
              (
                user?.profile?.firstName || user.profile?.lastName
                  ? (user?.profile?.firstName?.toLowerCase() || "") +
                  "." +
                  (user.profile?.lastName?.toLowerCase() || "")
                  : `user# ${user.objectIds.toString()}`
              ),
            profileImage: user?.profileImage ?? {},
            roleId: user?.roleId,
            status: user?.status,
          };
        });
    } catch (e) {
      console.log("something went wrong");
    }

    resolvedData.sort((a, b) => (a.beamId > b.beamId) ? 1 : ((b.beamId > a.beamId) ? -1 : 0))
    return resolvedData;
  }



  const aggregateUser = (inputQueryId: string, filterText?: string) => {


    var searchQuery = `@userType:{user}`;
    if (filterText) {
      if (filterText.length > 2) {
      searchQuery += formatUserFilterText(filterText);
      } else if (filterText.length > 0 && filterText.length <= 2) {
        return;
      }
    }

    setIsLoading(true);

    dispatch(GET_AGGREGATE({
      requestData: {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status",
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      },
      callback: (response) => {
        const formattedResponse = formatAggregateUserResponse(response);
        console.log("aggregate user response", formattedResponse);
        setAggregateUsers(formattedResponse);
        setIsLoading(false);
      },
    }));

    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    //     "CID"
    //   )}/service/bds/aggregateBds`,
    //   wrapRequestPayload(
    //     {
    //       select: {
    //         index: {
    //           searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
    //           searchQuery: searchQuery,
    //           searchOptions: "TIMEOUT 10000",
    //         },
    //         list: {
    //           inputQueryId: inputQueryId,
    //         },
    //         load: {
    //           objectId: "$.objectId",
    //           liveObject: "$.persistent.static",
    //           status: "$.nonpersistent.static.live.status",
    //         },
    //       },
    //       groupBy: {
    //         properties: ["@objectId"],
    //         reducers: [
    //           {
    //             func: "TOLIST",
    //             arguments: ["@liveObject"],
    //             name: "profile",
    //           },
    //         ],
    //       },
    //       apply: {
    //         expression: "",
    //         name: "",
    //       },
    //       filter: {
    //         expression: "",
    //       },
    //       result: {
    //         pagination: {
    //           offset: 0,
    //           limit: 10000,
    //         },
    //       },
    //       anyStatus: false,
    //     },
    //     requestIds.user
    //   )
    // );
  };

  useEffect(() => {
    if (selectedItem) {
      const orgGroups =
        selectedItem?.persistent?.static?.metadata?.members?.orgGroups || {};
      const users =
        selectedItem?.persistent?.static?.metadata?.members?.users || {};
      const orgUsersSet = new Set([]);
      Object.keys(orgGroups)?.map((group) => {
        orgGroups[group].userIds.map((user) => {
          orgUsersSet.add(user);
        });
      });
      const orgUsersArray = Array.from(orgUsersSet);

      orgUsersArray.map((user) => {
        if (users?.[user]?.role === "write") {
          delete users?.[user];
        }
      });

      setSelectedUsers(users);
      setSelectedGroups(orgGroups);
      setIsDoneBtnLoading(false);
      if (isDoneBtnLoading) {
        onClose();
      }
      if (selectedFilter === tabs.Groups) {
        setMarkedGroups([]);
        setCombinedGroups(combinedGroups.filter((group) => !group.marked));
      }
    }
  }, [selectedItem]);

  // useEffect(() => {
  //   if (findUsersToPage) {
  //     aggregateUser(findUsersToPage.queryId);
  //   }
  // }, [findUsersToPage]);

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const onPeopleMarkChange = (user, event, index) => {
    let checked = event.target.checked;
    if (checked) {
      user.role =
        user.id == localStorage.getItem("RID")
          ? UserRoles.Edit
          : UserRoles.Write;
      combinedUsers[index].marked = true;
      setMarkedUsers([...markedUsers, user]);
    } else {
      combinedUsers[index].marked = false;
      setMarkedUsers(markedUsers.filter((x) => x.id !== user.id));
    }
    setCombinedUsers(combinedUsers);
  };

  const onPageMarkChange = (page, event, index) => {
    let checked = event.target.checked;
    if (checked) {
      combinedPages[index].marked = true;
      setMarkedPages([...markedPages, page]);
    } else {
      combinedPages[index].marked = false;
      setMarkedPages(markedPages.filter((x) => x.pageId !== page.pageId));
    }
    setCombinedPages(combinedPages);
  };

  useEffect(() => {
    setIsLoading(false);
    let pagesList = userSearchPage;
    if (markedPages?.length) {
      markedPages.forEach((element) => {
        let markedIndex = pagesList.findIndex((x) => x.id == element.id);
        if (markedIndex !== -1 && searchInput) {
          pagesList[markedIndex].marked = true;
        } else if (!searchInput) {
          element.marked = true;
          pagesList.unshift(element);
        }
      });
    }
    setCombinedPages(
      pagesList?.filter((page) => {
        return (
          page.pageId !== selectedItem.pageId && page.organization === undefined
        );
      })
    );
  }, [userSearchPage?.length]);

  useEffect(() => {
    setIsLoading(false);
    let usersList = aggregateUsers as any[];
    if (markedUsers?.length) {
      markedUsers.forEach((element) => {
        let markedIndex = usersList.findIndex((x) => x.id == element.id);
        if (markedIndex !== -1 && searchInput) {
          usersList[markedIndex].marked = true;
        } else if (!searchInput) {
          element.marked = true;
          usersList.unshift(element);
        }
      });
    }
    setCombinedUsers(usersList);
  }, [aggregateUsers]);

  useEffect(() => {
    setIsLoading(false);
    let groupsList = [];
    adminSearchGroup?.forEach((page) => {
      if (
        !Object.keys(selectedGroups).find(
          (item) => selectedGroups[item]?.queryId === page.objectId.toString()
        )
      ) {
        groupsList.push(page);
      }
    });
    if (markedGroups?.length) {
      markedGroups.forEach((element) => {
        let markedIndex = groupsList.findIndex(
          (x) => x.objectId == element.objectId
        );
        if (markedIndex !== -1 && searchInput) {
          groupsList[markedIndex].marked = true;
        } else if (!searchInput) {
          element.marked = true;
          groupsList.unshift(element);
        }
      });
    }
    setCombinedGroups(groupsList);
  }, [adminSearchGroup?.length]);

  const doneAction = () => {
    switch (selectedFilter) {
      case tabs.People:
        addUsers(markedUsers);
        break;
      case tabs.Groups:
        addGroups();
        break;
      case tabs.Pages:
        addPages();
        break;
      default:
        break;
    }
  };

  const addPages = () => {
    setIsDoneBtnLoading(true);
    let users = [];
    markedPages.map((page) => {
      if (page?.organization?.queryId) {
        addGroup(page);
      } else {
        Object.keys(page.members).map((member) => {
          if (!Object.keys(selectedUsers).find((item) => item === member)) {
            users.push({
              id: member,
              beamId: page.members[member].beamId,
            });
          }
        });
      }
    });
    if (users.length) addUsers(users);
    else {
      pushNotification("All page members are already added", "warning");
      setIsDoneBtnLoading(false);
    }
  };

  const addGroups = () => {
    setIsDoneBtnLoading(true);
    markedGroups.forEach((group) => {
      addGroup({
        organization: {
          queryId: group.objectId.toString(),
        },
        members: {},
        title: group.info.name,
      });
    });
  };

  useEffect(() => {
    console.log("allUsers", aggregateUsers);
    if (allUsers?.length) {
      let usersList = allUsers as any[];
      if (markedUsers?.length) {
        markedUsers.forEach((element) => {
          let markedIndex = usersList.findIndex((x) => x.id == element.id);
          if (markedIndex !== -1 && searchInput) {
            usersList[markedIndex].marked = true;
          } else if (!searchInput) {
            element.marked = true;
            usersList.unshift(element);
          }
        });
      }
      setCombinedUsers(usersList);
    }
  }, [allUsers]);

  const addUsers = (_users: any[]) => {
    setIsDoneBtnLoading(true);
    let expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 1);
    const currentUser = allUsers?.find(
      (obj) => obj.id === localStorage.getItem("RID")
    );
    let users;
    _users.map((user) => {
      users = { ...selectedUsers, [user.id]: { role: "write" } };
      sendPageUpdateEvent("addPageMember", {
        userId: user.id,
        beamId: user.beamId || `${user.firstName}.${user.lastName}`,
        role: "write",
        pending: {
          invited: true,
          expiresAt: expiresAt.getTime(),
          invitedBy: currentUser?.beamId,
        },
      });
    });
    setSelectedUsers(users);
    setMarkedUsers([]);
  };

  const addGroup = (group) => {
    sendPageUpdateEvent("addAdminGroup", {
      queryId: group.organization.queryId,
      name: group.title,
      defaultRole: "write",
    });
  };

  const onGroupMarkChange = (group, event, index) => {
    let checked = event.target.checked;
    if (checked) {
      combinedGroups[index].marked = true;
      setMarkedGroups([...markedGroups, group]);
    } else {
      combinedGroups[index].marked = false;
      setMarkedGroups(
        markedGroups.filter((x) => x.objectId !== group.objectId)
      );
    }
    setCombinedGroups(combinedGroups);
  };

  useEffect(() => {
    setIsLoading(false);
  }, [searchTimestamp, adminSearchGroup?.length, groupSearchTimestamp]);

  return (
    <React.Fragment>
      <Row className="d-flex mt-1 mb-4">
        <Col span={24}>
          <h3>
            <button
              style={{ verticalAlign: "bottom" }}
              onClick={onClose}
              className="b-0 rm-b"
            >
              <ArrowLeftOutlined />
            </button>
            Add participants
          </h3>
        </Col>
      </Row>
      {((selectedItem && selectedItem.currentUserRole === "edit") ||
        isCreatePage) && (
          <Row>
            <Col span={24}>
              <small>Enter at least 3 characters</small>
              <Input
                onChange={(e) => {
                  let value: string = e.target.value;
                  setSearchInput(value);
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    // if (value === undefined || value === ""){
                    //   if (findUsersToPage && selectedFilter === tabs.People) {
                        
                    //   }
                    //   return;
                    // };
                    if (value.includes("-")) value = formatForRedis(value);
                    if (findUsersToPage && selectedFilter === tabs.People) {
                      
                      aggregateUser(findUsersToPage?.queryId, value);
                    } else if (selectedFilter === tabs.Groups) {
                      setIsLoading(true);
                      dispatch(
                        GET_ADMIN_GROUPS({
                          search: value,
                          serviceId: projects?.userServiceId,
                        })
                      );
                    } else if (selectedFilter === tabs.Pages) {
                      dispatch(GET_PAGE({ search: value }));
                    }
                  }, 500);
                }}
                placeholder={`Search ${selectedFilter}`}
                suffix={<SearchOutlined />}
                allowClear
              />
            </Col>
          </Row>
        )}
      <Row>
        <Col span={24}>
          {isLoading && (
            <div id="loading">
              <Spin className="mt-5" tip="Loading">
                <div className="content" />
              </Spin>
            </div>
          )}
        </Col>
      </Row>
      <Tabs
        defaultActiveKey="people"
        onChange={(key) => setSelectedFilter(key)}
      >
        <TabPane
          className="scroll-bar"
          style={{ height: "300px" }}
          tab="People"
          key={tabs.People}
        >
          <div className="w-full">
            <span className="pull-right mr-3">
              Selected:{markedUsers?.length}
            </span>
          </div>
          {(!combinedUsers || !combinedUsers?.length) && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
          {combinedUsers &&
            combinedUsers.map(
              (user, index) =>
                !selectedUsers[user.id] && (
                  <AvatarItem
                    key={user.id}
                    isSelect={true}
                    user={user}
                    index={index}
                    selectedItem={isCreatePage ? { ...selectedItem, currentUserRole: 'edit' } : selectedItem}
                    onPeopleMarkChange={(user, e) =>
                      onPeopleMarkChange(user, e, index)
                    }
                  ></AvatarItem>
                )
            )}
        </TabPane>
        <TabPane
          className="scroll-bar"
          style={{ height: "300px" }}
          tab="Groups"
          key={tabs.Groups}
        >
          <div className="w-full">
            <span className="pull-right mr-3">
              Selected:{markedGroups?.length}
            </span>
          </div>
          {(!adminSearchGroup || !adminSearchGroup?.length) && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
          {combinedGroups &&
            combinedGroups.map((group, index) => (
              <PageAvatarItem
                isGroup={true}
                title={group.info.name}
                showMembers={true}
                key={group.objectId}
                isSelect={true}
                data={group}
                allUsers={allUsers}
                index={index}
                selectedItem={isCreatePage ? { ...selectedItem, currentUserRole: 'edit' } : selectedItem}
                onMarkChange={(user, e) => onGroupMarkChange(user, e, index)}
              ></PageAvatarItem>
            ))}
        </TabPane>
        <TabPane
          className="scroll-bar"
          style={{ height: "300px" }}
          tab="Pages"
          key={tabs.Pages}
        >
          <div className="w-full">
            <span className="pull-right mr-3">
              Selected:{markedPages?.length}
            </span>
          </div>
          {(!userSearchPage || !userSearchPage?.length) && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}

          {combinedPages &&
            combinedPages.map((page, index) => (
              <PageAvatarItem
                title={page.title}
                showMembers={true}
                key={page.pageId}
                isSelect={true}
                data={page}
                allUsers={allUsers}
                index={index}
                selectedItem={isCreatePage ? { ...selectedItem, currentUserRole: 'edit' } : selectedItem}
                onMarkChange={(user, e) => onPageMarkChange(user, e, index)}
              ></PageAvatarItem>
            ))}
        </TabPane>
      </Tabs>
      <Row>
        <Col className="text-center" span={24}>
          <Button
            loading={isDoneBtnLoading}
            disabled={
              (selectedFilter == tabs.People &&
                (!markedUsers || !markedUsers.length)) ||
              (selectedFilter == tabs.Groups &&
                (!markedGroups || !markedGroups.length)) ||
              (selectedFilter == tabs.Pages &&
                (!markedPages || !markedPages.length))
            }
            onClick={
              !isCreatePage
                ? doneAction
                : () => onDone(markedUsers, markedGroups, markedPages)
            }
            style={{ top: "14px" }}
            key="submit"
            className="beam-btn green-btn cover"
          >
            {isDoneBtnLoading ? "Saving" : "Done"}
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AddPeople;
